<template>
	<div class="user_box">
		<div class="header">My account</div>
		<div class="user_item flex">
			<div class="name">Profile picture:</div>
			<div class="photo">
				<img :src="userInfo.avatar ? imgBaseUrl + userInfo.avatar : require('../../../assets/images/icon/photo.png')" alt="">
			</div>
		</div>
		<div class="user_item">First name：{{userInfo.first_name}}</div>
		<div class="user_item">Last name：{{userInfo.last_name}}</div>
		<div class="user_item">Address line 1：{{userInfo.address_line_one}}</div>
		<div class="user_item">Address line 2：{{userInfo.address_line_two}}</div>
		<div class="user_item">Town：{{userInfo.town}}</div>
		<div class="user_item">Postcode：{{userInfo.psot_code}}</div>
		<div class="user_item">Email：{{userInfo.email}}</div>
		<div class="user_item">Mobile:{{userInfo.mobile}}</div>
		<div class="user_item"> Note：{{userInfo.remark}}</div>
		<!-- <div class="user_item">备注：</div> -->
		<div class="edit_btn" @click="toEdit">Edit</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				userInfo:{}
			}
		},
		created(){
			this.getDetail();
		},
		methods:{
			getDetail(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			toEdit(){
				this.$router.push('/home/userInfo/editUser')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.user_box{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 0 40px 60px;
		.header{
			width: 100%;
			height: 90px;
			line-height: 90px;
			border-bottom: 1px solid #5C707A;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		.user_item{
			margin-top: 20px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			.photo{
				width: 122px;
				height: 122px;
				border-radius: 50%;
				overflow: hidden;
				img{
					width: 100%;
					height: 100%;
				}
			}
		}
		.edit_btn{
			width: 181px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			margin-top: 40px;
			line-height: 57px;
			text-align: center;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
	}
</style>